/**
 * @Author：zsj
 * @Date：2022/03/08
 */

import React from 'react';
import { Navigate } from "react-router-dom";
import { DesktopOutlined, DiffOutlined, FileOutlined, PieChartOutlined } from "@ant-design/icons";

const Home = React.lazy(() => import("@/pages/home/index"));
const NotFond = React.lazy(() => import("@/pages/common/not-found"));
const HomeSubPage1 = React.lazy(() => import("@/pages/home/page1"));
const HomeSingleSubPage1 = React.lazy(() => import("@/pages/home/singlePage1"));

const Index = React.lazy(() => import("@/pages/index"));
const Login = React.lazy(() => import("@/pages/login"));
const Msg = React.lazy(() => import("@/pages/msg"));
const AbleStatus = React.lazy(() => import("@/pages/able-status"));
const QuotationList = React.lazy(() => import("@/pages/quotation-list"));
const QuotationDetail = React.lazy(() => import("@/pages/quotation-list/quotation-detail"));


// 路由配置目前只支持到二级路由

export const page404 = {
    id: '404',
    name: '404',
    path: '*',
    component: NotFond
};

export const defaultPage = {
    id: 'all',
    path: "/",
    exact: true,
    render: () => (
        <Navigate to="/login" />
    )
}

export const loginPage = {
    id: 'login',
    name: '登录',
    exact: true,
    path: "/login",
    component: Login
};

const routes = [
    {
        hide: true,
        id: 'homePageId',
        name: '首页',
        path: "/home",
        component: Home,
        routes: [
            {
                id: 'homeSubPageId',
                name: '首页下的二级页面--跟首页内容同时展示',
                exact: true,
                path: "page1",
                component: HomeSubPage1,
                isSub: true,
            },
            {
                id: 'homeModuleSinglePageId',
                name: 'home模块下的单独页面--不跟首页内容同时展示',
                exact: true,
                path: "page2/:id",
                component: HomeSingleSubPage1
            },
        ]
    },
    {
        id: 'index',
        name: '账号列表',
        exact: true,
        path: "/index",
        component: Index,
    },
    {
        id: 'msg',
        name: '短信列表',
        exact: true,
        path: "/msg",
        component: Msg,
    },
    {
        id: 'ableStatus',
        name: '使用状态',
        exact: true,
        path: "/able-status",
        component: AbleStatus,
    },

    {
        id: 'quotationList',
        name: '报价列表',
        exact: true,
        path: "/quotation",
        component: QuotationList,
        routes: [
            {
                id: 'quotationDetail',
                name: '报价详情',
                exact: true,
                path: "detail/:id",
                component: QuotationDetail,
            },
        ]
    },


];

const getFlatPermissionMap = (routerArr, routeNameKey) => {
    const tempMap = {};
    const generateMap = (arr) => {
        arr.forEach((info) => {
            const { routes } = info;
            tempMap[info[routeNameKey]] = info;
            if (routes && routes.length) {
                generateMap(routes);
            }
        });
    };
    generateMap(routerArr);
    return tempMap;
};

export const getFlatRoutesMap = () => {
    const tempMap = {};
    const generateMap = (arr) => {
        arr.forEach((info) => {
            const { routes } = info;
            tempMap[info.id] = info;
            if (routes && routes.length) {
                generateMap(routes);
            }
        });
    };
    generateMap(routes);
    return tempMap;
};


// 只支持配置到二级菜单
export const getMenuListFromPermission = routerArr => {

    const permissionMap = getFlatPermissionMap(routerArr, 'id')

    const filterRoutes = routes.filter(i => !i.hide && permissionMap[i.id])
    const itemList = []

    const listItemMap = {}

    filterRoutes.forEach(i => {
        listItemMap[i.id] = {
            ...i,
            selectedKeys: [i.id],
            openKeys: [i.id]
        }
        const tempRoute = {
            key: i.id,
            label: i.name,
        }
        const subRoutes = [...i.routes || []].filter(i => i.subMenu)
        if (subRoutes.length) {
            tempRoute.children = []
            subRoutes.forEach(s => {
                listItemMap[s.id] = {
                    ...s,
                    selectedKeys: [i.id, s.id],
                    openKeys: [i.id, s.id],
                    path: `${i.path}/${s.path}`
                }
                tempRoute.children.push({
                    key: s.id,
                    label: s.name,
                })
            })
        }
        itemList.push(tempRoute)
    })

    return { itemList, listItemMap }
}


export default routes;
